import { Vector4 } from "three";
import * as three from "three";
import getMaterialWithUniforms from "../../instancing/materials/getMaterialWithUniforms";
import RectangleMesh from "../../instancing/Meshes/RectangleMesh";
import createPatternTexture from "../../instancing/textures/createPatternTexture";

const { normal, rectUv } = createPatternTexture({
  width: 8,
  height: 8,
});

export function getSelectionMesh() {
  const conf = {
    rgbaCode: 1,
    posX: 1,
    posY: 1,
  };
  const materialConf = getMaterialWithUniforms({
    disableRaycast: true,
    transparent: true,
    depthTest: false,
    depthWrite: false,
    antialias: true,
  })
    .setPaddingX([-0.5, 0.5, -0.5, 0.5])
    .setPaddingY([0, 0, 0, 0])
    .setOffset([0, 0])
    .setBorderWidth(10)
    .setColorMap([new Vector4(1, 0.2, 0.2, 1)]);

  return new RectangleMesh(materialConf, conf);
}

export function getLoadingMesh() {
  const conf = {
    rgbaCode: 1,
    posX: 1,
    posY: 1,
  };
  const materialConf = getMaterialWithUniforms({
    disableRaycast: true,
    depthTest: false,
    depthWrite: false,
    transparent: true,
    alphaTest: 0.9,
  })
    .setPaddingX([0, 0, 0, 0])
    .setPaddingY([0, 0, 1, 1])
    .setOffset([0, 0])
    .setColorMap([new three.Vector4(0.3, 0.1, 1, 1)]);

  return new RectangleMesh(materialConf, conf);
}

export function getErrorsMesh() {
  const texture = normal;
  const conf = {
    rgbaCode: 1,
    posX: 1,
    posY: 1,
  };
  const materialConf = getMaterialWithUniforms({
    disableRaycast: true,
    depthTest: false,
    depthWrite: false,
    transparent: true,
    alphaTest: 0.001,
    ...texture,
  })
    .setPaddingX([0, 0, 0, 0])
    .setPaddingY([0, 0, 0, 0])
    .setOffset([0, 0])
    .setTexture(texture.texture)
    .setTextureUvMap(rectUv)
    .setColorMap([new three.Vector4(1, 0.1, 0.3, 1)]);

  return new RectangleMesh(materialConf, conf);
}

export function getUnloadedMesh() {
  const texture = normal;
  const conf = {
    rgbaCode: 1,
    posX: 1,
    posY: 1,
  };
  const materialConf = getMaterialWithUniforms({
    disableRaycast: true,
    transparent: true,
    depthTest: false,
    depthWrite: false,
    alphaTest: 0.1,
    ...texture,
  })
    .setPaddingX([0, 0, 0, 0])
    .setPaddingY([0, 0, 0, 0])
    .setOffset([0, 0])
    .setTexture(texture.texture)
    .setTextureUvMap(rectUv)
    .setColorMap([new three.Vector4(1, 0.1, 0.3, 1)]);

  return new RectangleMesh(materialConf, conf);
}

export function drawArea(areas, mesh) {
  const count = areas.length;
  const isAppend = false;
  const setX = mesh.updateX({ count, isAppend });
  const setY = mesh.updateY({ count, isAppend });

  for (let i = 0; i < count; i++) {
    const [a, b, c, d] = areas[i];
    setX(i, a, b, a, b);
    setY(i, c, c, d, d);
  }
}
